//@ts-check
import React from 'react';
import {node, oneOfType, string} from 'prop-types';
import classNames from 'classnames';
import styles from './Field.css';

/**
 * @typedef {object} FieldProps
 * @prop {*} [className] classNames.js compatible value
 * @prop {React.ReactNode} [label]
 * @prop {React.ReactNode} children
 * @prop {string} [htmlFor]
 */

/**
 * Wraps a form element with a label on top. `htmlFor` sets the `for` attribute on the label.
 * @type {React.SFC<FieldProps>}
 */
const Field = ({className, label, children, htmlFor}) => (
  <div className={classNames(styles.Field, className)}>
    {label && <label className={styles.FieldHeader} {...{htmlFor}}>{label}</label>}
    <div>{children}</div>
  </div>
);
Field.displayName = 'Field';
Field.propTypes = {
  className: string, //null is fine
  label: oneOfType([string, node]),
  children: node.isRequired,
  htmlFor: string, //null is fine
};

Field.defaultProps = {
  className: '',
  label: undefined,
  htmlFor: '',
};

export default Field;
